import React from 'react';
import { MoonLoader } from 'react-spinners';

function Spinner({ text }: { text?: string }) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
        backgroundColor: 'var(--spinner-bg, #ffffff)',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 9999,
      }}
    >
      <MoonLoader
        color="var(--spinner-accent, #FF7235)"
        loading
        size={60}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
      {text && (
        <p
          style={{
            marginTop: 20,
            fontSize: '1.1rem',
            fontWeight: 600,
            color: 'var(--spinner-color, #333333)',
            letterSpacing: '0.5px',
            textAlign: 'center',
            maxWidth: '80%',
            lineHeight: 1.4,
            animation: 'spinnerFade 1.5s ease-in-out infinite',
          }}
        >
          {text}
        </p>
      )}
      <style>{`
        @keyframes spinnerFade {
          0%   { opacity: 0.4; }
          50%  { opacity: 1; }
          100% { opacity: 0.4; }
        }
      `}</style>
    </div>
  );
}

export default Spinner;
